"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowSignable__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [],
  name: "CallerNotBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "CallerNotEndorser",
  type: "error"
}, {
  inputs: [],
  name: "CallerNotHolder",
  type: "error"
}, {
  inputs: [],
  name: "DualRoleRejectionRequired",
  type: "error"
}, {
  inputs: [],
  name: "ECDSAInvalidSignature",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "length",
    type: "uint256"
  }],
  name: "ECDSAInvalidSignatureLength",
  type: "error"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "s",
    type: "bytes32"
  }],
  name: "ECDSAInvalidSignatureS",
  type: "error"
}, {
  inputs: [],
  name: "EmptyReceivingData",
  type: "error"
}, {
  inputs: [],
  name: "InactiveTitleEscrow",
  type: "error"
}, {
  inputs: [],
  name: "InvalidEndorsement",
  type: "error"
}, {
  inputs: [],
  name: "InvalidInitialization",
  type: "error"
}, {
  inputs: [],
  name: "InvalidNominee",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "registry",
    type: "address"
  }],
  name: "InvalidRegistry",
  type: "error"
}, {
  inputs: [],
  name: "InvalidSignature",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }],
  name: "InvalidTokenTransferToZeroAddressOwners",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTransferToZeroAddress",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "endorsedBeneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "currentBeneficiary",
    type: "address"
  }],
  name: "MismatchedEndorsedBeneficiaryAndCurrentBeneficiary",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "endorsedNominee",
    type: "address"
  }, {
    internalType: "address",
    name: "onChainNominee",
    type: "address"
  }],
  name: "MismatchedEndorsedNomineeAndOnChainNominee",
  type: "error"
}, {
  inputs: [],
  name: "NomineeAlreadyNominated",
  type: "error"
}, {
  inputs: [],
  name: "NotInitializing",
  type: "error"
}, {
  inputs: [],
  name: "RecipientAlreadyHolder",
  type: "error"
}, {
  inputs: [],
  name: "RegistryContractPaused",
  type: "error"
}, {
  inputs: [],
  name: "RemarkLengthExceeded",
  type: "error"
}, {
  inputs: [],
  name: "SignatureAlreadyCancelled",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "currentTimestamp",
    type: "uint256"
  }],
  name: "SignatureExpired",
  type: "error"
}, {
  inputs: [],
  name: "TargetNomineeAlreadyBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "TitleEscrowNotHoldingToken",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotReturnedToIssuer",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "BeneficiaryTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "hash",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "endorser",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "CancelBeneficiaryTransferEndorsement",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "HolderTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint64",
    name: "version",
    type: "uint64"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "prevNominee",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "Nomination",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferBeneficiary",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferHolder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferOwners",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "caller",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "ReturnToIssuer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "Shred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [],
  name: "BENEFICIARY_TRANSFER_TYPEHASH",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "DOMAIN_SEPARATOR",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "active",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "beneficiary",
      type: "address"
    }, {
      internalType: "address",
      name: "holder",
      type: "address"
    }, {
      internalType: "address",
      name: "nominee",
      type: "address"
    }, {
      internalType: "address",
      name: "registry",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    internalType: "struct BeneficiaryTransferEndorsement",
    name: "endorsement",
    type: "tuple"
  }],
  name: "cancelBeneficiaryTransfer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "cancelled",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "holder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_registry",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "isHoldingToken",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "nominate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "nominee",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "nonces",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "prevBeneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "prevHolder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "registry",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "remark",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "returnToIssuer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "shred",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "tokenId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "transferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "beneficiary",
      type: "address"
    }, {
      internalType: "address",
      name: "holder",
      type: "address"
    }, {
      internalType: "address",
      name: "nominee",
      type: "address"
    }, {
      internalType: "address",
      name: "registry",
      type: "address"
    }, {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }],
    internalType: "struct BeneficiaryTransferEndorsement",
    name: "endorsement",
    type: "tuple"
  }, {
    components: [{
      internalType: "bytes32",
      name: "r",
      type: "bytes32"
    }, {
      internalType: "bytes32",
      name: "s",
      type: "bytes32"
    }, {
      internalType: "uint8",
      name: "v",
      type: "uint8"
    }],
    internalType: "struct SigHelper.Sig",
    name: "sig",
    type: "tuple"
  }],
  name: "transferBeneficiaryWithSig",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newHolder",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "transferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "address",
    name: "newHolder",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "transferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class TitleEscrowSignable__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.TitleEscrowSignable__factory = TitleEscrowSignable__factory;
_defineProperty(TitleEscrowSignable__factory, "bytecode", _bytecode);
_defineProperty(TitleEscrowSignable__factory, "abi", _abi);